<template>
  <div class="d-flex flex-grow-1">
    <v-col :cols="cols[0]" :offset="offset[0]">
      <v-select
        v-model="reactiveValue.gre"
        :label="labelGre"
        :items="form.lists.gres"
        :item-text="'nome'"
        :multiple="multiple"
        :rules="[v => this.isGreRequired(v)]"
        :disabled="disabled"
        outlined
        dense
        return-object
      >
      </v-select>
    </v-col>
    <v-col :cols="cols[1]" :offset="offset[1]">
      <v-select
        v-model="reactiveValue.municipio"
        :items="computedListMunicipios"
        :item-text="'nome'"
        :label="labelMunicipio"
        :multiple="multiple"
        :rules="[v => this.isMunicipioRequired(v)]"
        outlined
        dense
        return-object
        :disabled="disabled || disabledMunicipio"
      ></v-select>
    </v-col>
  </div>
</template>

<script>
import GreMunicipioService from '~/services/gre-municipio.service';

export default {
  name: "greCidadeComponent",
  mixins: [GreMunicipioService],
  props: {
    cols: {
      type: Array,
      default: () => [6, 6]
    },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    value: {
      type: Object,
      default: () => ({
        gre: [],
        municipio: [],
      })
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    greRequired: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    form: {
      lists: {
        gres: [],
        municipios: [],
      }
    }
  }),
  computed: {
    reactiveValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    labelGre() {
      return (this.greRequired || this.required) ? 'GRE*' : 'GRE'
    },
    labelMunicipio() {
      return (this.required) ? 'Município*' : 'Município'
    },
    computedListMunicipios() {
      return this.multiple
        ? this.form.lists.municipios.filter(m =>!this.reactiveValue.gre || this.reactiveValue.gre.map(g => g.id).includes(m.gre))
        : this.form.lists.municipios.filter(m =>!this.reactiveValue.gre || this.reactiveValue.gre.id === m.gre);
    },
    disabledMunicipio() {
      return this.multiple ? !this.reactiveValue.gre?.length : !this.reactiveValue.gre
    }
  },
  watch: {
    'reactiveValue.gre': function (gre) {
      if (this.multiple && this.reactiveValue.municipio) {
        let greIds = gre.map(g => g.id)
        this.reactiveValue.municipio = this.reactiveValue.municipio.filter(m =>
          greIds.includes(m.gre))
      } else {
        this.reactiveValue.municipio = null
      }
    }
  },
  methods: {
    buscarGreMunicipios() {
      this.$buscarGreMunicipios().then(({data}) => {
        this.form.lists.gres = data.resposta.gres;
        this.form.lists.municipios = data.resposta.municipios;
      })
    },
    isGreRequired(v) {
      return (this.greRequired || this.required)
        ? this.$required(v) : true
    },
    isMunicipioRequired(v) {
      return this.required
        ? this.$required(v) : true
    }
  },
  mounted() {
    this.buscarGreMunicipios();
  }
}
</script>
